import RequestList from './RequestList'
import AssignmentIcon from '@mui/icons-material/Assignment'

export default {
  list: RequestList,
  icon: AssignmentIcon,
}
